import React, { useContext, useEffect, useState } from "react";
import LoadingIcon from "../../images/Loading_icon.gif";
import { AppContext } from "../../contexts/AppContext";
import { useNavigate } from "react-router-dom";

export default function ViewProjectInfo({ projectInfo, setShowProjectInfo }) {
  const [projStartDate, setProjStartDate] = useState("");
  const [projDeadline, setProjDeadline] = useState("");
  const [projLanguages, setProjLanguages] = useState([]);
  const [loadingPopup, setLoadingPopup] = useState(false);

  const navigate = useNavigate();

  const fetchProjectInfo = () => {
    setShowProjectInfo(true);
  };

  useEffect(() => {
    if (projectInfo?.projStartDate) {
      const date = new Date(projectInfo.projStartDate);
      if (isNaN(date)) return;
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const formattedDate = `${day < 10 ? "0" + day : day}/${
        month < 10 ? "0" + month : month
      }/${date.getFullYear()}`;
      setProjStartDate(formattedDate);
    }
  }, [projectInfo.projStartDate]);

  useEffect(() => {
    if (projectInfo?.projDeadline) {
      const date = new Date(projectInfo.projDeadline);
      if (isNaN(date)) return;
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const formattedDate = `${day < 10 ? "0" + day : day}/${
        month < 10 ? "0" + month : month
      }/${date.getFullYear()}`;
      setProjDeadline(formattedDate);
    }
  }, [projectInfo.projDeadline]);

  useEffect(() => {
    if (projectInfo?.languageList?.length > 0) {
      const languages = projectInfo.languageList.map(
        (language) => language.languageCode + ", "
      );
      languages[languages.length - 1] = languages[languages.length - 1].slice(
        0,
        -2
      );
      setProjLanguages(languages);
    }
  }, [projectInfo.languageList]);

  return (
    <>
      <button
        className="btn"
        title="View Project Info"
        onClick={fetchProjectInfo}
        style={{ width: "100%" }}
      >
        <i className="fa-solid fa-eye"></i> Project Info
      </button>

      {loadingPopup && (
        <div className="deletePrj-popup-wrapper">
          <div className="tab-pane fade show deletePrj-div">
            <center>
              <p style={{ fontSize: "18px" }}>
                Loading data. Please wait . . .
              </p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </>
  );
}
